import { HttpRepository } from '@/modules/shared/shared/domain/repositories/http.repository';
import { LookupResponse } from '@/modules/users/domain/lookup-response';
import { RecoveryPasswordRequest } from '@/modules/users/domain/recovery-password-request';
import { LoginRequest } from '@/modules/users/domain/login-request';
import { User } from '@/modules/users/domain/user';

export class UsersRepository extends HttpRepository {
    private static readonly RESOURCE = 'users';

    /**
     * Check if the user is already registered and return its customers' ids.
     * @return LookupResponse
     * @param username: email of the user to check
     * */
    async lookUp(username: string): Promise<LookupResponse> {
        return (await this.post(`lookup`, { username }, undefined)).data;
    }

    /**
     * Request an email for password recovery
     * @return void
     * @param recoveryPasswordRequest: email and customer of the user that request the recovery
     * */
    async recoveryPassword(recoveryPasswordRequest: RecoveryPasswordRequest) {
        return (await this.post(`forgot-password`, recoveryPasswordRequest, undefined)).data;
    }

    /**
     * Sign in an user and return the current user
     * @return User
     * @param loginRequest: username, password and customer that sign in the system
     * */
    async login(loginRequest: LoginRequest): Promise<User> {
        return (await this.post(`authorize`, loginRequest, undefined)).data;
    }
}

export const userRepository = new UsersRepository();
